const IntegrationCommonIconCircle = () => {
  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20.3333" r="20" fill="var(--primaryLight)" />
      <path
        d="M12.9688 16.2708C11.3318 16.2708 10 14.9391 10 13.302C10 11.665 11.3318 10.3333 12.9688 10.3333C14.6058 10.3333 15.9375 11.665 15.9375 13.302C15.9375 14.939 14.6058 16.2708 12.9688 16.2708ZM12.9688 11.5833C12.021 11.5833 11.25 12.3542 11.25 13.302C11.25 14.2498 12.021 15.0208 12.9688 15.0208C13.9165 15.0208 14.6875 14.2498 14.6875 13.302C14.6875 12.3542 13.9165 11.5833 12.9688 11.5833Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
      <path
        d="M27.0313 16.2708H20.147C18.51 16.2708 17.1782 14.9391 17.1782 13.3021C17.1782 11.6651 18.51 10.3333 20.147 10.3333H27.0313C28.6684 10.3333 30.0001 11.665 30.0001 13.302C30.0001 14.939 28.6683 16.2708 27.0313 16.2708ZM20.147 11.5833C19.1992 11.5833 18.4282 12.3542 18.4282 13.302C18.4282 14.2498 19.1992 15.0208 20.147 15.0208H27.0313C27.9791 15.0208 28.7501 14.2498 28.7501 13.302C28.7501 12.3542 27.9791 11.5833 27.0313 11.5833H20.147Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
      <path
        d="M12.9688 23.3021C11.3318 23.3021 10 21.9703 10 20.3333C10 18.6962 11.3318 17.3645 12.9688 17.3645C14.6058 17.3645 15.9375 18.6963 15.9375 20.3333C15.9375 21.9703 14.6058 23.3021 12.9688 23.3021ZM12.9688 18.6145C12.021 18.6145 11.25 19.3855 11.25 20.3333C11.25 21.2811 12.021 22.052 12.9688 22.052C13.9165 22.052 14.6875 21.2811 14.6875 20.3333C14.6875 19.3855 13.9165 18.6145 12.9688 18.6145Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
      <path
        d="M27.0313 23.3021H20.147C18.51 23.3021 17.1782 21.9703 17.1782 20.3333C17.1782 18.6963 18.51 17.3645 20.147 17.3645H27.0313C28.6684 17.3645 30.0001 18.6963 30.0001 20.3333C30.0001 21.9703 28.6683 23.3021 27.0313 23.3021ZM20.147 18.6145C19.1992 18.6145 18.4282 19.3855 18.4282 20.3332C18.4282 21.281 19.1992 22.052 20.147 22.052H27.0313C27.9791 22.052 28.7501 21.281 28.7501 20.3332C28.7501 19.3855 27.9791 18.6145 27.0313 18.6145H20.147Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
      <path
        d="M12.9688 30.3335C11.3318 30.3335 10 29.0018 10 27.3648C10 25.7278 11.3318 24.396 12.9688 24.396C14.6058 24.396 15.9375 25.7278 15.9375 27.3648C15.9375 29.0018 14.6058 30.3335 12.9688 30.3335ZM12.9688 25.646C12.021 25.646 11.25 26.417 11.25 27.3647C11.25 28.3125 12.021 29.0835 12.9688 29.0835C13.9165 29.0835 14.6875 28.3125 14.6875 27.3647C14.6875 26.417 13.9165 25.646 12.9688 25.646Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
      <path
        d="M27.0313 30.3335H20.147C18.51 30.3335 17.1782 29.0018 17.1782 27.3648C17.1782 25.7278 18.51 24.396 20.147 24.396H27.0313C28.6684 24.396 30.0001 25.7278 30.0001 27.3648C30.0001 29.0018 28.6683 30.3335 27.0313 30.3335ZM20.147 25.646C19.1992 25.646 18.4282 26.417 18.4282 27.3647C18.4282 28.3125 19.1992 29.0835 20.147 29.0835H27.0313C27.9791 29.0835 28.7501 28.3125 28.7501 27.3647C28.7501 26.417 27.9791 25.646 27.0313 25.646H20.147Z"
        fill="var(--primary)"
        stroke="var(--primary)"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default IntegrationCommonIconCircle;
